class SkProductRecommendations extends HTMLElement {
  #observer;
  #controller;

  connectedCallback() {
    if (this.dataset.loaded === 'true' || !this.dataset.url) return;

    this.#observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        this.#observer.disconnect();
        this.#load();
      },
      { rootMargin: '300px 0px' }
    );
    this.#observer.observe(this);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#controller?.abort();
  }

  async #load() {
    this.dataset.loaded = 'true';
    this.#controller = new AbortController();

    try {
      const response = await fetch(this.dataset.url, { signal: this.#controller.signal });
      if (!response.ok) throw new Error(`Recommendations request failed: ${response.status}`);

      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const incoming = parsed.querySelector(`sk-product-recommendations[data-section-id="${CSS.escape(this.dataset.sectionId)}"]`);
      if (!incoming) return;

      this.innerHTML = incoming.innerHTML;
      this.classList.toggle('is-empty', !this.querySelector('[data-product-card]'));
    } catch (error) {
      if (error.name !== 'AbortError') this.classList.add('is-empty');
    }
  }
}

if (!customElements.get('sk-product-recommendations')) {
  customElements.define('sk-product-recommendations', SkProductRecommendations);
}
